import { useState, useEffect, useContext } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { AppContext } from '../App';
import logo_wide from '../assets/logo_wide.png';
import { MdSend } from 'react-icons/md';
import { TbSend } from 'react-icons/tb';
import { RiAttachment2 } from 'react-icons/ri';
import { callApi, BASE_API, formatDate } from '../Helpers';
import { ChatContext } from '../views/CommunityChat';
import { AiOutlineUser, AiFillStar } from 'react-icons/ai';
import { BsReplyFill } from 'react-icons/bs';
import { AiOutlineArrowUp } from 'react-icons/ai'
import { ChatContext as CommunityChatContext } from '../views/CommunityChat';
import { ChatContext as ChatRoomChatContext } from '../views/ChatRoom';


export default function OneMessage (props) {

  const appContext = useContext(AppContext);
  const communityChatContext = useContext(CommunityChatContext);
  const chatRoomChatContext = useContext(ChatRoomChatContext);
  const chatContext = communityChatContext || chatRoomChatContext;


  const [ data, setData ] = useState(props.data);
  const [ id, setId ] = useState(props.id);

  const viewUserProfile = () => {
    appContext.navTo({
      item: 'view',
      subItem: 'browse_profile',
      extraItem: data.userId,
    });
  }

  const replyToMessage = () => {
    chatContext.setReplyTo({
      username: data.username,
      userId: data.userId,
      id,
    })
  }

  useEffect(() => {
    setData(props.data)
  }, [props.data])

  useEffect(() => {
    setId(props.id)
  }, [props.id])
  
  return (
    <div  
      id={"_message_"+id}
      style={{ width: "100%", display: "block" }}
      className={(appContext.userData.id === data.userId) ? 'd-flex justify-content-end' : 'd-flex justify-content-start'}
    >
      <div  className='mOneMessage' data-byuser={(appContext.userData.id === data.userId)}>
        {
          (data.replyTo && data.replyTo.username) ?
          <h6 
            onClick={() => chatContext.scrollToMessage(data.replyTo.id)} 
            style={{ cursor: "pointer", fontSize: "12px" }}
            className='font-bold text-goldish mOneLineText'
          >
            <AiOutlineArrowUp size={20}/>
            Replying to {data.replyTo.username}
          </h6>
          : ""
        }
        {
          (data.file) ?
          <img width="100%" height="auto" src={data.file} />
          :""
        }
        {
          (data.body) ?
          <p style={{ marginTop: "10px", fontSize: "13px" }}>
            {data.body}
          </p>
          : ""
        }

        {
          !(appContext.userData.id === data.userId) ?
          <>
            <h6 onClick={viewUserProfile} className='mOneLineText font-light text-goldish' style={{ marginTop: "20px", fontSize: "12px", cursor: "pointer" }}>
              <AiOutlineUser size={20}/>
              {data.username}
            </h6>
          </>
          : ""
        }

        <div className='d-flex justify-content-between'>
          <small className='text-muted align-self-center' style={{ fontSize: "12px" }}>{formatDate(data.time)}</small>
          
          {
            !(appContext.userData.id === data.userId) ?
            <BsReplyFill onClick={replyToMessage} size={20} className='align-self-center' style={{ cursor: "pointer" }}/>:""
          }
        </div>
      </div>
    </div>
  )
}
